import React, { useEffect, useState } from 'react'
import http, { URL_S3 } from '../../../../config/BaseUrl'
import '../../style/style.css'


function PropFilter(props) {

  const [propsItems, setPropsItem] = useState([])
  const [propFilter, setPropFilter] = useState([])
  const [loading, setLoading] = useState(false)
  const [submitClose, setSubmitClose] = useState(false)
  const [selectedAll, setSelectedAll] = useState(false)

  const FetchColorFilterItems = async () => {
    try {
      setLoading(true)
      await http.get("event-color-filter").then((res) => {
        if(res.data.filterColor){
          setPropFilter(res.data.filterColor)
          setLoading(false)
        }
      }).catch((err) => {
        setLoading(false)
      })
    } catch (error) {
      setLoading(false)
    }
  }

  const handleSubmit = () => {
    if (propsItems) {
      props.setData(propsItems)
    }
  }

  useEffect(() => {
    if (propsItems.length != props.propFilterItem.length) {
      setPropsItem(props.propFilterItem)
    }
    if (props.propFilterItem.length > 0) {
      setSelectedAll(true)
    }
    else{
      setSelectedAll(false)
    }
    FetchColorFilterItems()
  }, [props])

  const changeValue = (item) => {
    let copyItem = [...propsItems]
    let IndexOfItem = copyItem.findIndex(data => data.id === item.id)

    if (IndexOfItem >= 0) {
      copyItem.splice(IndexOfItem, 1)
      setPropsItem(copyItem)
    }
    else {
      setPropsItem([...copyItem, item])

    }

    setSubmitClose(true)

  }

  const selectAllData = () => {
    let copyItem = [...propsItems]
    let copyData = [...propFilter]
    if (!selectedAll) {
      copyData.forEach(itemData => {
        let dataSet = { id: itemData.id, image: itemData.filter_url }
        let IndexOfItem = copyItem.findIndex(data => data.id === dataSet.id)

        if (IndexOfItem < 0) {
          copyItem = [...copyItem, dataSet]
          setPropsItem(copyItem)
        }
      })
      setSelectedAll(true)

    }
    else{
      copyData.forEach(itemData => {
        let dataSet = { id: itemData.id, image: itemData.filter_url }
        let IndexOfItem = copyItem.findIndex(data => data.id === dataSet.id)

        if (IndexOfItem >= 0) {
          copyItem.splice(IndexOfItem, 1)
          setPropsItem(copyItem)
        }
      })

      setSelectedAll(false)
    }
    if (copyItem.length > 0) {
      setSubmitClose(true)
    }
    else {
      setSubmitClose(false)
    }
    
  }

  return (
    <div className="modal fade" id="props-filter-modal" tabindex="-1" role="dialog" aria-hidden="true">
      <div className="modal-dialog modal-xl">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Select Filter</h5>
            <button type="button" className="close" data-dismiss="modal" aria-label="Close">	<span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">

            <div className="tab-content template-content" id="email-temp-tabContent">
              <div
                className="tab-pane fade show active"
                id="email-temp-home"
                role="tabpanel"
                aria-labelledby="email-temp-home-tab"
              >
                <div className="standared-template">
                  <div className="row">
                    {loading ? 
                      <div className="text-center col-md-12">
                        <span className="spinner-border" role="status" aria-hidden="true"></span>
                      </div>
                    :propFilter.map((items) => (
                        <div key={items.id} className="my-2 col-md-2" onClick={e => changeValue({ id: items.id, image: items.filter_url })}>
                          <div className={`template-item ${propsItems && propsItems.findIndex(item => item.id === items.id) >= 0 && 'active-template'}`}>
                            <img src={`${URL_S3}image/color_filter/${items.filter_url}`} alt="template-1" className="img-fluid" />
                          </div>
                        </div>
                      ))
                    }
                  </div>

                </div>
              </div>
            </div>

          </div>
          <div className="modal-footer justify-content-lg-between">
            <div className="left-alignment">
              <button type="button" className="px-5 m-1 btn btn-secondary radius-30" onClick={selectAllData}>
                {
                  !selectedAll
                  ? "Select All"
                  : "Remove All"
                }
              </button>
            </div>
            <div className="right-alignment">
              <button type="button" className="px-5 m-1 btn btn-secondary radius-30" data-dismiss="modal">Close</button>
              <button type="button" className="px-5 m-1 btn btn-primary radius-30" onClick={handleSubmit} data-dismiss={submitClose && "modal"}>Save changes</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PropFilter
